// components/Pages/RM/Inventory/SyncInventoryModal.jsx
import React, { useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { FaSync, FaExclamationTriangle } from 'react-icons/fa';

const SyncInventoryModal = ({ show, onHide, onSync, rawMaterialCount, inventoryCount }) => {
    const [isSyncing, setIsSyncing] = useState(false);

    const handleSync = async () => {
        setIsSyncing(true);
        try {
            await onSync();
        } finally {
            setIsSyncing(false);
        }
    };

    const needsSync = rawMaterialCount > inventoryCount;

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FaSync className="me-2" />
                    Sync Inventory
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-4">
                    <div className="d-flex justify-content-between mb-2">
                        <span>Raw Materials:</span>
                        <strong>{rawMaterialCount}</strong>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                        <span>Inventory Records:</span>
                        <strong>{inventoryCount}</strong>
                    </div>
                    <div className="d-flex justify-content-between">
                        <span>Missing Records:</span>
                        <strong className={needsSync ? 'text-danger' : 'text-success'}>
                            {Math.max(0, rawMaterialCount - inventoryCount)}
                        </strong>
                    </div>
                </div>

                {needsSync ? (
                    <Alert variant="warning">
                        <FaExclamationTriangle className="me-2" />
                        {rawMaterialCount - inventoryCount} raw materials don't have inventory records.
                        Click "Sync Now" to create inventory records for all raw materials with zero stock.
                    </Alert>
                ) : (
                    <Alert variant="success">
                        All raw materials have inventory records. No sync needed.
                    </Alert>
                )}

                <Alert variant="info" className="mt-3">
                    <strong>What will happen:</strong>
                    <ul className="mb-0 mt-2">
                        <li>Inventory records will be created for all raw materials without inventory</li>
                        <li>Initial stock will be set to 0</li>
                        <li>Default thresholds will be applied (Min: 0, Reorder: 10)</li>
                        <li>Default location will be set to "Main Warehouse"</li>
                        <li>Existing inventory records will not be modified</li>
                    </ul>
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={isSyncing}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={handleSync}
                    disabled={!needsSync || isSyncing}
                >
                    {isSyncing ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Syncing...
                        </>
                    ) : (
                        <>
                            <FaSync className="me-2" />
                            Sync Now
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SyncInventoryModal;